/* @flow */

import { logInfo } from '../debug/debug';

export type PipDisabler = {
  isLocked: () => boolean,
  setLocked: (isLocked: boolean) => void,
};

const setupPipDisabler = (videoElement: HTMLVideoElement): PipDisabler => {
  let isLocked = false;

  // Intercept context menu when locked to prevent native Chrome PiP option
  const handleContextMenu = (e: SyntheticMouseEvent<HTMLElement> | SyntheticTouchEvent<HTMLElement>) => {
    if (isLocked) {
      e.preventDefault();
    }
  };

  videoElement.addEventListener('contextmenu', handleContextMenu);

  // Override disablePictureInPicture property
  Object.defineProperty(videoElement, 'disablePictureInPicture', {
    configurable: false,
    get: () => isLocked,
    set: () => {}, // Silently block console overwrites
  });

  // Override requestPictureInPicture method
  const originalRequestPiP = HTMLVideoElement.prototype.requestPictureInPicture;

  videoElement.requestPictureInPicture = (...args) => {
    if (isLocked) {
      logInfo('Nice try! 🥷🏼');
      return Promise.resolve();
    }

    // Explicitly bind execution context back to videoElement
    return originalRequestPiP.apply(videoElement, args);
  };

  // Return controller functions to update state cleanly
  return {
    isLocked: () => isLocked,
    setLocked: (locked: boolean) => {
      isLocked = Boolean(locked);

      if (isLocked) {
        // Toggle native DOM attribute for browser context menu compatibility
        videoElement.setAttribute('disablePictureInPicture', '');

        // Force exit PiP if active
        if (document.pictureInPictureElement === videoElement) {
          document.exitPictureInPicture().catch(() => {});
        }
      } else {
        // Re-enable PiP attribute and restore unmuted state
        videoElement.removeAttribute('disablePictureInPicture');
      }
    },
  };
};

export { setupPipDisabler };
